import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Divider } from '@material-ui/core';
import axios from 'axios';
import { UserAvatar } from '../AppBar/UserAvatar';
import {
    Wrapper,
    UserWrapperAdmin,
    UserWrapper,
    StyledLink,
    CreateButton,
    Button,
    SeparatorWrapper,
    Title,
    ButtonFree
} from './Drawer.styles';
import { DrawerProps } from './Drawer.interface';
import { useAuth } from '../../context/auth';
import { Verification } from '../dialogs/Verification';

export function Drawer({ user, close }: DrawerProps) {
    const location = useLocation();
    const [adminAccess, setAdminAccess] = useState<boolean>(false);
    const [verificationOpen, setVerificationOpen] = useState(false);
    const { refreshDovePoints, authToken, logout, wallet } = useAuth();
    const getFreePoints = () => {
        axios.post(`/wallet/api/payments/wallets/get-free-points/`, {}, {headers: { DTOKEN: `${authToken}`}}).then(res => {
            refreshDovePoints();
        })
    }
    useEffect(() => {
        if (user) {
            setAdminAccess(user.isAdmin);
        }
    }, [user])
    return (
        <Wrapper>
            {user ?
                <>
                    {adminAccess ?
                        <UserWrapperAdmin>
                            <UserAvatar userName={user.displayName} size="70px" negative fontSize="18px" />
                            <p>{user.displayName}</p>
                        </UserWrapperAdmin>
                    :
                        <UserWrapper>
                            <UserAvatar userName={user.displayName} size="70px" negative fontSize="18px" />
                            <div>
                                <h1>{user.displayName}</h1>
                                <span className="label">DovePoints</span>
                                <h3>{wallet ? wallet.availablePoints : 0}</h3>
                            </div>
                        </UserWrapper>
                    }
                    <div>
                        <Divider variant="middle" />
                        <StyledLink onClick={() => close()} to={`${process.env.REACT_APP_INTERNAL_URL}dashboard`}>Dashboard</StyledLink>
                        {adminAccess ?
                            <>
                                <StyledLink onClick={() => close()} to={`${process.env.REACT_APP_INTERNAL_URL}my-campaigns`}>Campaigns</StyledLink>
                                <StyledLink onClick={() => close()} to={`${process.env.REACT_APP_INTERNAL_URL}clients`}>Clients</StyledLink>
                                <StyledLink onClick={() => close()} to={`${process.env.REACT_APP_INTERNAL_URL}support-panel`}>Support</StyledLink>
                            </>
                            : <StyledLink onClick={() => close()} to={`${process.env.REACT_APP_INTERNAL_URL}my-campaigns`}>My campaigns</StyledLink>
                        }
                        {user.verifiedAccount
                            ?
                                <>
                                {(wallet && wallet.hasWallet)
                                    ?
                                    <>
                                        {location.pathname === `${process.env.REACT_APP_INTERNAL_URL}create-campaign`
                                        ? <ButtonFree>Create Campaign</ButtonFree>
                                        : <CreateButton onClick={() => close()} to={{
                                            pathname: `${process.env.REACT_APP_INTERNAL_URL}create-campaign`,
                                            }}>Create Campaign</CreateButton>
                                        }
                                    </>
                                    :
                                    <ButtonFree onClick={getFreePoints}>Free points</ButtonFree>
                                }
                                </>
                            :
                                <>
                                    <ButtonFree onClick={() => setVerificationOpen(true)}>{(wallet && wallet.hasWallet) ? 'Create Campaign' : ' Free points'}</ButtonFree>
                                </>
                        }
                        <Divider variant="middle" />
                        <Button onClick={() => {
                            logout();
                            close();
                        }} to={`${process.env.REACT_APP_INTERNAL_URL}`}>Logout</Button>
                    </div>
                </>
                :
                <>
                        <Title>Create advertising campaigns <br/>
                            in the DoveMed ecosystem</Title>
                        <CreateButton to={{
                            pathname: location.pathname,
                            state: { openLogin: true }
                        }}>Create campaign</CreateButton>
                        <Button to={{
                            pathname: location.pathname,
                            state: { openLogin: true }
                        }}>Login</Button>
                        <SeparatorWrapper>
                            <span>OR</span>
                            <Divider variant="middle" />
                        </SeparatorWrapper>
                        <Button to={{
                            pathname: location.pathname,
                            state: { openLogin: true }
                        }}>Register</Button>
                </>
            }
            <Verification open={verificationOpen} setOpen={setVerificationOpen} />
        </Wrapper>
    );
}
